/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from 'react';
import { Form, Select, Button, Input, Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { type AppDispatch } from '../../../redux/store';
import {
  getBankInterestSchemeAction,
  updateBankInterestSchemeAction,
  // updateBankInterestSchemeAction,
} from '../store/interestSchemeActions';
import { type BankInterest } from '../store/interestSchemeTypes';
import OutlinedButton from '../../../components/ButtonComponent/OutlinedButton';
import { type InterestRate } from '../../Pledge/store/pledgeTypes';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';

export default function BankTableIndex(): JSX.Element {
  const dispatch = useDispatch<AppDispatch>();

  const [editingSchemeId, setEditingSchemeId] = useState<string | null>(null);
  const [goldRates, setGoldRates] = useState<Record<string, number>>({});
  const [documentChargeTypes, setDocumentChargeTypes] = useState<
    Record<string, string>
  >({});
  const [documentCharges, setDocumentCharges] = useState<
    Record<string, number>
  >({});
  const [appraisalChargeTypes, setAppraisalChargeTypes] = useState<
    Record<string, string>
  >({});
  const [appraisalCharges, setAppraisalCharges] = useState<
    Record<string, number>
  >({});

  const [bankInterestSchemes, setBankInterestSchemes] = useState<any>({});

  const [branchOptions, setBranchOptions] = useState<
    Array<{ label: string; value: string }>
  >([]);

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const [branch, setBranch] = useState<any>('');

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
    }
  }, []);

  useEffect(() => {
    if (branchOptions.length > 0) {
      setBranch(branchOptions[0].value);
    }
  }, [branchOptions]);

  const updateBankInterest = async (id: string): Promise<void> => {
    const action = updateBankInterestSchemeAction;
    const response = await action(dispatch, {
      id,
      minGoldRate: goldRates[id],
      documentChargeType: documentChargeTypes[id],
      documentCharge: documentCharges[id],
      appraisalChargeType: appraisalChargeTypes[id],
      appraisalCharge: appraisalCharges[id],
    });

    if (response !== false) {
      // Update local state instead of refetching
      const updatedSchemes = { ...bankInterestSchemes };
      Object.keys(updatedSchemes).forEach((bank: string) => {
        updatedSchemes[bank] = updatedSchemes[bank].map((scheme: any) => {
          if (scheme.id === id) {
            return {
              ...scheme,
              minGoldRate: goldRates[id],
              documentChargeType: documentChargeTypes[id],
              documentCharge: documentCharges[id],
              appraisalChargeType: appraisalChargeTypes[id],
              appraisalCharge: appraisalCharges[id],
            };
          }
          return scheme;
        });
      });
      setBankInterestSchemes(updatedSchemes);
    }
  };

  const updateBankInterestActiveStatus = async (
    id: string,
    status: boolean
  ): Promise<void> => {
    const action = updateBankInterestSchemeAction;
    const response = await action(dispatch, {
      id,
      isActive: status,
    });

    if (response !== false) {
      // Update local state instead of refetching
      const updatedSchemes = { ...bankInterestSchemes };
      Object.keys(updatedSchemes).forEach((bank: string) => {
        updatedSchemes[bank] = updatedSchemes[bank].map((scheme: any) => {
          if (scheme.id === id) {
            return {
              ...scheme,
              isActive: status,
            };
          }
          return scheme;
        });
      });
      setBankInterestSchemes(updatedSchemes);
    }
  };

  const getInterestSchemes = async (): Promise<void> => {
    setBankInterestSchemes({});
    const data: any = await getBankInterestSchemeAction(dispatch, { branch });
    if (data) {
      const initialGoldRates: Record<string, number> = {};
      const initialDocumentChargeTypes: Record<string, string> = {};
      const initialDocumentCharges: Record<string, number> = {};
      const initialAppraisalChargeTypes: Record<string, string> = {};
      const initialAppraisalCharges: Record<string, number> = {};

      const values = Object.values(data);

      values.forEach((schemes: any) => {
        schemes.forEach((scheme: any) => {
          initialGoldRates[scheme.id] = scheme.minGoldRate ?? 0;
          initialDocumentChargeTypes[scheme.id] =
            scheme.documentChargeType ?? 'Fixed';
          initialDocumentCharges[scheme.id] = scheme.documentCharge ?? 0;
          initialAppraisalChargeTypes[scheme.id] =
            scheme.appraisalChargeType ?? 'Fixed';
          initialAppraisalCharges[scheme.id] = scheme.appraisalCharge ?? 0;
        });
      });

      setGoldRates(initialGoldRates);
      setDocumentChargeTypes(initialDocumentChargeTypes);
      setDocumentCharges(initialDocumentCharges);
      setAppraisalChargeTypes(initialAppraisalChargeTypes);
      setAppraisalCharges(initialAppraisalCharges);
      setBankInterestSchemes(data);
    }
  };

  return (
    <div className="pledge__table__page">
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h1>Bank schemes</h1>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Form.Item
            name="branch"
            rules={[{ required: true, message: 'Please select a branch' }]}
            style={{ margin: 'auto', paddingRight: '60px' }}
          >
            <Select
              value={branchOptions[0]?.value}
              onChange={(value: string): void => {
                setBranch(value);
              }}
              style={{ width: 311, height: 56 }}
              placeholder="Select branch"
              options={branchOptions}
              className="pledge__input"
            />
          </Form.Item>
          <OutlinedButton
            label="Search"
            onClick={() => {
              void getInterestSchemes();
            }}
          />
        </div>
      </div>

      {Object.keys(bankInterestSchemes).map((bank: string) => (
        <div key={bank} className="all-interest">
          <div className="container">
            <div className="interest">
              <div
                style={{
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 16,
                }}
              >
                Bank Name:{' '}
                <p style={{ fontSize: 14, color: '#DD1E26' }}>{bank}</p>
              </div>
              {bankInterestSchemes[bank].map((bankInterest: BankInterest) => (
                <div key={bankInterest.schemeLimit}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <h3>
                      {bankInterest.totalMonths} month scheme&nbsp;-&nbsp;
                      {bankInterest.schemeLimit}
                    </h3>
                    {editingSchemeId === bankInterest.id ? (
                      <>
                        <Button
                          icon={<SaveOutlined />}
                          onClick={() => {
                            void updateBankInterest(bankInterest.id);
                            setEditingSchemeId(null);
                          }}
                          size="small"
                          color="#181818"
                        />
                        <Button
                          icon={<span style={{ fontSize: 16 }}>&times;</span>}
                          onClick={() => {
                            setEditingSchemeId(null);
                          }}
                          size="small"
                        />
                      </>
                    ) : (
                      <Button
                        icon={<EditOutlined />}
                        onClick={() => {
                          setEditingSchemeId(bankInterest.id);
                        }}
                        size="small"
                        shape="circle"
                      />
                    )}
                  </div>
                  <Switch
                    onChange={async () => {
                      await updateBankInterestActiveStatus(
                        bankInterest.id,
                        !bankInterest.isActive
                      );
                    }}
                    checked={bankInterest.isActive}
                  />
                  {bankInterest.interestRates.map(
                    (interestType: InterestRate) => (
                      <div key={interestType.startDate}>
                        <p>
                          {interestType.startDate}-{interestType.endDate}:{' '}
                          {interestType.interest}%
                        </p>
                      </div>
                    )
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginTop: 8,
                    }}
                  >
                    <p>Calculation Interest Type:&nbsp;</p>
                    <span>{bankInterest.interestType ?? 'Simple'}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p>Min Gold Rate:&nbsp;</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {editingSchemeId === bankInterest.id ? (
                        <Input
                          type="number"
                          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                          value={goldRates[bankInterest.id] || 0}
                          onChange={(e) => {
                            setGoldRates({
                              ...goldRates,
                              [bankInterest.id]: Number(e.target.value),
                            });
                          }}
                          style={{ width: 120 }}
                          placeholder="Enter rate"
                          autoFocus
                        />
                      ) : (
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        <span>{goldRates[bankInterest.id] || 0}</span>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: 8,
                    }}
                  >
                    <p>Document Charge Type:&nbsp;</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {editingSchemeId === bankInterest.id ? (
                        <Select
                          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                          value={
                            documentChargeTypes[bankInterest.id] || 'Fixed'
                          }
                          onChange={(value: string) => {
                            setDocumentChargeTypes({
                              ...documentChargeTypes,
                              [bankInterest.id]: value,
                            });
                          }}
                          style={{ width: 120 }}
                          options={[
                            { label: 'Fixed', value: 'Fixed' },
                            { label: 'Percent', value: 'Percent' },
                          ]}
                        />
                      ) : (
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        <span>
                          {documentChargeTypes[bankInterest.id] || 'Fixed'}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: 8,
                    }}
                  >
                    <p>
                      Document Charge{' '}
                      {documentChargeTypes[bankInterest.id] === 'Percent'
                        ? '(%)'
                        : ''}
                      :&nbsp;
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {editingSchemeId === bankInterest.id ? (
                        <Input
                          type="number"
                          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                          value={documentCharges[bankInterest.id] || 0}
                          onChange={(e) => {
                            setDocumentCharges({
                              ...documentCharges,
                              [bankInterest.id]: Number(e.target.value),
                            });
                          }}
                          style={{ width: 120 }}
                          placeholder="Enter charge"
                        />
                      ) : (
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        <span>{documentCharges[bankInterest.id] || 0}</span>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: 8,
                    }}
                  >
                    <p>Appraisal Charge Type:&nbsp;</p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {editingSchemeId === bankInterest.id ? (
                        <Select
                          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                          value={
                            appraisalChargeTypes[bankInterest.id] || 'Fixed'
                          }
                          onChange={(value: string) => {
                            setAppraisalChargeTypes({
                              ...appraisalChargeTypes,
                              [bankInterest.id]: value,
                            });
                          }}
                          style={{ width: 120 }}
                          options={[
                            { label: 'Fixed', value: 'Fixed' },
                            { label: 'Percent', value: 'Percent' },
                          ]}
                        />
                      ) : (
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        <span>
                          {appraisalChargeTypes[bankInterest.id] || 'Fixed'}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: 8,
                    }}
                  >
                    <p>
                      Appraisal Charge{' '}
                      {appraisalChargeTypes[bankInterest.id] === 'Percent'
                        ? '(%)'
                        : ''}
                      :&nbsp;
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      {editingSchemeId === bankInterest.id ? (
                        <Input
                          type="number"
                          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                          value={appraisalCharges[bankInterest.id] || 0}
                          onChange={(e) => {
                            setAppraisalCharges({
                              ...appraisalCharges,
                              [bankInterest.id]: Number(e.target.value),
                            });
                          }}
                          style={{ width: 120 }}
                          placeholder="Enter charge"
                        />
                      ) : (
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        <span>{appraisalCharges[bankInterest.id] || 0}</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
